import { isPlatformBrowser } from '@angular/common';
import { CookieOptions } from '@laurentgoudet/ngx-cookie';

export function cookieOptionsFactory(platformId: Object): CookieOptions {
  return isPlatformBrowser(platformId)
    ? {
        path: '/',
        domain: window.location.hostname.match(/freelancer.*$/)
          ? `.${(<string[]>window.location.hostname.match(/freelancer.*$/))[0]}`
          : `${window.location.hostname}`,
        secure: window.location.protocol === 'https',
      }
    : {};
}



// WEBPACK FOOTER //
// ./src/app/cookie-options.factory.ts